export class MainSceneModel {

    isLoading: boolean = true
    isBlur: boolean = false

}